import Api from '../Api';

export const getFactories = () => async dispatch => {
  const { data } = await Api.get('/dropdowns/factories');
  dispatch({
    type: 'FETCH_FACTORIES',
    payload: data,
  });
};

export const clearFactories = () => {
  return {
    type: 'CLEAR_FACTORIES',
  };
};

export const getFactory = id => async dispatch => {
  const { data } = await Api.get(`/dropdowns/factories/${id}`);
  dispatch({
    type: 'FETCH_FACTORY',
    payload: data,
  });
};

export const clearFactory = () => {
  return {
    type: 'CLEAR_FACTORY',
  };
};

export const getFactoryIds = () => async dispatch => {
  const { data } = await Api.get('/dropdowns/factories/ids');
  dispatch({
    type: 'FETCH_FACTORY_IDS',
    payload: data,
  });
};

export const clearFactoryIds = () => {
  return {
    type: 'CLEAR_FACTORY_IDS',
  };
};
